<template>
  <div></div>
</template>

<script>
import api from "../api/index";
import AuthUrlGenerator from "../handler/wx.auth.handler/auth.url.generator";
import AuthParamsParser from "../handler/wx.auth.handler/auth.params.parser";
import AuthPageDisperser from "../handler/wx.auth.handler/auth.page.dispenser";
import handleWxConfig from "../handler/wx.sdk.handler/wx.conf.handler";

export default {
  name: "auth_page",
  computed: {},
  mounted() {
    const params = this.$route.query || {};

    const authUrlGenerator = new AuthUrlGenerator();
    const authParamsParser = new AuthParamsParser();
    const authPageDisperser = new AuthPageDisperser();

    authParamsParser
      .setParams(params)
      .isGetToken((res) => {
        api.getAuthToken(res.code).then(() => {
          authPageDisperser.action(res);
        });
      })
      .isRefreshToken((res) => {
        const authUrl = authUrlGenerator
          .setOptions()
          .setState({
            ...params,
          })
          .getAuthUrl();

        window.location.href = authUrl;
      });
  },
};
</script>
